export default __webpack_public_path__ + "static/media/todo.a1a9b10c.png";